import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'listToString'
})
export class ListStringPipe implements PipeTransform {

  transform(value: any, campo: string, prefixo?: string): any {

    if (!value || !Array.isArray(value) || value.length === 0) {
      return null;
    }

    prefixo = prefixo ? prefixo + ' ' : '';

    return prefixo + value.map((item: any) => item[campo]).join(', ');
  }

}
